import { Navigate } from 'react-router';

function SignUp() {
    return <Navigate to="/login" replace />;
}

export default SignUp;
